import { render, staticRenderFns } from "./Sdevice.vue?vue&type=template&id=85543c36&"
import script from "./Sdevice.vue?vue&type=script&lang=ts&"
export * from "./Sdevice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports